// extracted by mini-css-extract-plugin
export default {"container":"src-styles-portfolio-__portfolio_router__container__2oXWp"};